import { render, staticRenderFns } from "./FingerClick.vue?vue&type=template&id=1f1ea752&"
import script from "./FingerClick.vue?vue&type=script&lang=js&"
export * from "./FingerClick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports